import React from 'react';

const MyFatorahStatusModal = ({ isOpen, onClose, statusData }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b">
          <h3 className="text-lg font-semibold text-gray-900">
            MyFatorah Status Details
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {statusData ? (
            <div className="space-y-4">
              {/* Status Overview */}
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="text-md font-medium text-gray-800 mb-3">Account Status</h4>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <span className="text-sm font-medium text-gray-600 mr-2">Approved:</span>
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                      statusData.IsApproved 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {statusData.IsApproved ? 'Yes' : 'No'}
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-sm font-medium text-gray-600 mr-2">Active:</span>
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                      statusData.IsActive 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {statusData.IsActive ? 'Yes' : 'No'}
                    </span>
                  </div>
                </div>
              </div>

              {/* Financial Details */}
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="text-md font-medium text-gray-800 mb-3">Financial Summary</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-md p-3 border">
                    <div className="text-sm font-medium text-gray-600">Total Balance</div>
                    <div className="text-lg font-semibold text-blue-600">
                      {statusData.TotalBalance?.toLocaleString() || '0'} KD
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-md p-3 border">
                    <div className="text-sm font-medium text-gray-600">Awaiting Balance</div>
                    <div className="text-lg font-semibold text-orange-600">
                      {statusData.TotalAwaitingBalance?.toLocaleString() || '0'} KD
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-md p-3 border">
                    <div className="text-sm font-medium text-gray-600">Deposited Amount</div>
                    <div className="text-lg font-semibold text-green-600">
                      {statusData.TotalDepositedAmount?.toLocaleString() || '0'} KD
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-md p-3 border">
                    <div className="text-sm font-medium text-gray-600">Awaiting Transfer</div>
                    <div className="text-lg font-semibold text-purple-600">
                      {statusData.TotalAwaitingToTransfer?.toLocaleString() || '0'} KD
                    </div>
                  </div>
                </div>
              </div>

              {/* Transaction Details */}
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="text-md font-medium text-gray-800 mb-3">Transaction Summary</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-md p-3 border">
                    <div className="text-sm font-medium text-gray-600">Total Transactions</div>
                    <div className="text-lg font-semibold text-gray-800">
                      {statusData.TotalNumberOfTransactions?.toLocaleString() || '0'}
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-md p-3 border">
                    <div className="text-sm font-medium text-gray-600">Transaction Value</div>
                    <div className="text-lg font-semibold text-gray-800">
                      {statusData.TotalValueOfTransactions?.toLocaleString() || '0'} KD
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-md p-3 border md:col-span-2">
                    <div className="text-sm font-medium text-gray-600">Supplier Invoice Share</div>
                    <div className="text-lg font-semibold text-gray-800">
                      {statusData.TotalSupplierInvoiceShare?.toLocaleString() || '0'} KD
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-500">No status data available</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end p-6 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyFatorahStatusModal;